import { Link, useNavigate } from "react-router-dom";
import { getCart, isCartValid } from "../../utility/Cookies";
import {
  ABOUTUS_URL_LOCAL,
  CONTACTUS_URL_LOCAL,
  FAQ_URL_LOCAL,
  LOGIN_URL_LOCAL,
  SECTION_USER_URL_LOCAL,
  REGISTER_URL_LOCAL,
  SHOPPINGCART_URL_LOCAL,
  PROFILE_URL_LOCAL,
  CHANGE_PASSWORD_URL_LOCAL,
  SEARCH_PRODUCT_URL_LOCAL,
  BASE_URL,
  HOME_URL_LOCAL,
} from "../../utility/BaseUrl";
import DropdownBasketComponent from "./headerComponent/DropdownBasketComponent";
import { handleLogout } from "../../utility/PublicComponent";
import MenuOffcanvasComponent from "./headerComponent/MenuOffcanvasComponent";
import { BasketBoxComponent2 } from "./headerComponent/BasketBoxComponent";
import MenuMobileComponent from "./headerComponent/MenuMobileComponent";

function Header({ setData, category, fullName, about, cart, setting }) {
  let navigate = useNavigate();

  return (
    <>
      {/* loading */}
      <div className="loading" />
      {/* header */}
      <header className="header">
        {/* header desktop */}
        {/* banner top */}
        {/* banner top */}
        <div className="d-none d-lg-block">
          <div className="header-desktop">
            <div className="container">
              <div className="header-top py-10 py-lg-15">
                <div className="row align-items-center">
                  <div className="col-9 col-md-8">
                    <div className="d-flex align-items-center">
                      <h1 className="header-sitename">
                        فروشگاه اینترنتی صوت برتر
                      </h1>
                      {setting[0] ? (
                        <Link className="d-block" to={HOME_URL_LOCAL}>
                          <img
                            src={BASE_URL + setting[0].site_logo}
                            alt={setting[0].logo_alt}
                            title={setting[0].logo_title}
                            style={{ maxWidth: "64px" }}
                            className="header-logo img-fluid"
                          />
                        </Link>
                      ) : null}
                      <div className="header-search mx-lg-25">
                        <form
                          className="header-search-form"
                          onSubmit={(e) => {
                            e.preventDefault();
                            const query = e.target.q.value;
                            navigate(
                              SEARCH_PRODUCT_URL_LOCAL +
                                `?search=${encodeURIComponent(query)}`
                            );
                          }}
                        >
                          <input
                            type="text"
                            name="q"
                            className="form-control header-search-input"
                            placeholder="جستجو ..."
                          />
                          <button
                            className="btn btn-primary header-search-submit d-none"
                            type="submit"
                          >
                            <i className="fa fa-search" />
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-8 col-lg-4">
                    <div className="d-flex justify-content-end align-items-center h-100">
                      {!fullName ? (
                        <>
                          <Link
                            to={LOGIN_URL_LOCAL}
                            className="btn btn-link ml-10 top-menu-user"
                          >
                            <i className="fa fa-user" />
                            <span className="d-none d-lg-inline-block">
                              ورود
                            </span>
                          </Link>
                          <Link
                            to={REGISTER_URL_LOCAL}
                            className="btn btn-link ml-10 top-menu-user"
                          >
                            <i className="fa fa-user-plus"></i>
                            <span className="d-none d-lg-inline-block">
                              نام‌نویسی
                            </span>
                          </Link>
                        </>
                      ) : (
                        <div className="dropdown">
                          <a
                            href="/user"
                            className="btn1 btn-sec ml-10 dropdown-toggle top-menu-user-loggedin"
                            data-toggle="dropdown"
                            role="button"
                            aria-expanded="false"
                          >
                            <i className="fa fa-user ml-half" />
                            <span className="d-none d-lg-inline-block">
                              {fullName}
                            </span>
                          </a>
                          <div className="dropdown-menu">
                            <Link
                              to={SECTION_USER_URL_LOCAL}
                              className="dropdown-item"
                            >
                              <i className="fa fa-fw ml-1 mt-1 fa-user" />
                              بخش کاربری
                            </Link>
                            <Link
                              to={PROFILE_URL_LOCAL}
                              className="dropdown-item"
                            >
                              <i className="fa fa-fw ml-1 mt-1 fa-pencil" />
                              ویرایش مشخصات
                            </Link>
                            <Link
                              to={CHANGE_PASSWORD_URL_LOCAL}
                              className="dropdown-item"
                            >
                              <i className="fa fa-fw ml-1 mt-1 fa-lock" />
                              تغییر رمز عبور
                            </Link>
                            <Link
                              onClick={() => handleLogout(navigate)}
                              className="dropdown-item"
                            >
                              <i className="fa fa-fw ml-1 mt-1 fa-power-off" />
                              خروج
                            </Link>
                          </div>
                        </div>
                      )}
                      <div className="top-menu-basket">
                        <DropdownBasketComponent
                          setData={setData}
                          cart={cart}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="header-menu">
              <div className="container">
                <div className="position-relative">
                  <div className="navbar-mega-container d-inline-block">
                    <a href="#" className="mega-menu-title">
                      <i className="fa fa-bars align-middle ml-half" />
                      دسته بندی محصولات
                    </a>
                    <div className="navbar-mega-context shadow">
                      <nav className="navbar-mega" role="navigation">
                        <div id="navbar-104790707">
                          <ul className="navbar-nav" role="menu">
                            {category
                              ? category
                                  .filter((item) => {
                                    return !item.parent;
                                  })
                                  .map((item, index) => {
                                    const queryParams = new URLSearchParams({
                                      category: item.title,
                                    }).toString();

                                    return (
                                      <li
                                        key={index}
                                        className="nav-item position-static"
                                      >
                                        <Link
                                          to={
                                            SEARCH_PRODUCT_URL_LOCAL +
                                            `?${queryParams}`
                                          }
                                          className="nav-link"
                                        >
                                          {item.title}
                                        </Link>
                                        <div class="nav-subset nav-subset-0">
                                          <div class="nav-subset-list">
                                            {category
                                              .filter((subItem) => {
                                                let filter =
                                                  subItem.parent == item.id;
                                                return filter;
                                              })
                                              .map((subItem, subIndex) => {
                                                const queryParams =
                                                  new URLSearchParams({
                                                    category: subItem.title,
                                                  }).toString();
                                                return (
                                                  <Link
                                                    key={`${index}${subIndex}`}
                                                    to={
                                                      SEARCH_PRODUCT_URL_LOCAL +
                                                      `?${queryParams}`
                                                    }
                                                    class="nav-subset-link"
                                                  >
                                                    {subItem.title}
                                                  </Link>
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </li>
                                    );
                                  })
                              : null}
                          </ul>
                        </div>
                      </nav>
                    </div>
                  </div>
                  <nav
                    className="navbar navbar-expand-lg d-inline-block p-0"
                    role="navigation"
                  >
                    <div className="container" navbar-menu>
                      <button
                        type="button"
                        className="navbar-toggler"
                        data-toggle="collapse"
                        data-target="#navbar-107401150"
                        aria-expanded="false"
                        aria-controls="navbar"
                      >
                        <span className="navbar-toggler-icon" />
                      </button>
                      <a
                        className="navbar-brand d-lg-none float-left"
                        href="javascript:;"
                      >
                        منوی وب‌سایت
                      </a>
                      <div
                        id="navbar-107401150"
                        className="navbar-collapse collapse"
                      >
                        <ul className="navbar-nav" role="menu">
                          <li className="nav-item ">
                            <Link to={FAQ_URL_LOCAL} className="nav-link">
                              پرسش های متداول
                            </Link>
                          </li>
                          <li className="nav-item ">
                            <Link to={CONTACTUS_URL_LOCAL} className="nav-link">
                              ارتباط با ما
                            </Link>
                          </li>
                          <li className="nav-item ">
                            <Link to={ABOUTUS_URL_LOCAL} className="nav-link">
                              درباره ما
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </nav>
                  {about && about[0] ? (
                    <div
                      className="header-contact d-inline-block"
                      style={{ float: "left", marginTop: 12 }}
                    >
                      <span className="d-none d-lg-inline-block align-middle">
                        {about[0].site_phone}
                      </span>
                      <img
                        className="header-contact-icon align-middle"
                        src="/themes/custom-1a98/images/phone.png"
                        alt={about[0].site_phone}
                        title={about[0].site_phone}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* header mobile */}
        <MenuOffcanvasComponent
          about={about}
          category={category}
          setting={setting}
        />
      </header>
      {/* mainMenu */}
      <MenuMobileComponent cart={cart} fullName={fullName} setData={setData} />
    </>
  );
}

export default Header;
